import React from 'react'
import { Loading } from '../../root/components/common'
import { isEmptyList } from '../../../utils'
import { makeStyles } from '@material-ui/core/styles'

export default function HotSwapLoader({ list, isLoading }) {
    const classes = useStyles()

    return (
        <>
            {isEmptyList(list) && isLoading && (
                <div className={classes.loader}>
                    <Loading />
                </div>
            )}
        </>
    )
}

const useStyles = makeStyles(() => ({
    loader: {
        display: 'flex',
        alignSelf: 'center'
    }
}))
